import { atom, useAtom } from 'jotai';
import { TurnaroundEntity } from '../models';

const turnaroundDestinationEntities = atom<Array<TurnaroundEntity>>([]);

export const useTurnaroundDestinationEntities = () => useAtom(turnaroundDestinationEntities);
